<template>
    <div class="airPurifiers_main" :class="{'cn':version == '1'}">
        <div class="airPurifiers_left">
            <!-- <side-bar></side-bar> -->
        </div>
        <div class="airPurifiers_right">
            <div class="airPurifiers_right_top">
                <div class="right_top_l">
                    <el-select v-model="buildId">
                        <el-option
                            v-for="item in buildNav"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <el-input :placeholder="$t('App.lights.text24')" v-model="keywords" @keyup.native="getPurifierListKeyUp($event)" class="input-with-select">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="getPurifierList()"></i>
                    </el-input>
                </div>
            </div>
            <div class="airPurifiers_right_main">
                <div class="main_top">
                    <div class="main_top_l">
                        <div class="div1"><span>{{$t('App.sideBar.text9')}}</span></div>
                        <div class="div2">
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{$t('App.lights.text10')}}</el-checkbox>
                            <div class="btn" @click="postDelLight(checkList,'batch')">
                                <i class="iconfont icon-delete"></i>
                                <span>{{$t('App.lights.text1')}}</span>
                            </div>
                            <div class="btn" @click="postReData(checkList)" v-loading="reDataIndex>0">
                                <i class="iconfont icon-refresh"></i>
                                <span>{{$t('App.lights.text4')}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="main_top_r">
                        <div class="btn" @click="addPurifierFun()"><img :src="img_lights_3"><span>{{$t('App.lights.text5')}}</span></div>
                    </div>
                </div>
                <div class="main_cont">
                    <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
                        <el-table
                            ref="purifierDataList"
                            v-loading="loading.purifierDataList"
                            height="100%"
                            :data="purifierDataList">
                            <el-table-column
                                :label="$t('App.lights.text33')"
                                :prop="'index'"
                                align="left"
                                header-align="center"
                                :width="6*remRatio">
                                <template slot-scope="scope">
                                    <el-checkbox :label="scope.row.id" :key="scope.row.id">{{scope.row.webIndex}}</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column
                                :label="$t('App.room.text42')"
                                :prop="'name'"
                                header-align="left"
                                align="left"
                                :show-overflow-tooltip="true"
                                :min-width="6.5*remRatio">
                            </el-table-column>
                            <el-table-column
                                :label="$t('App.room.text43')"
                                :prop="'deviceId'"
                                align="center"
                                :show-overflow-tooltip="true"
                                :min-width="6.5*remRatio">
                            </el-table-column>
                            <el-table-column
                                v-for="(item) in lightArr"
                                :key="'table_'+item.prop"
                                :prop="item.prop"
                                :label="item.label"
                                :align="item.align?item.align:'center'"
                                :width="item.width"
                                :show-overflow-tooltip="true"
                                :min-width="item.minWidth">
                                    <template slot-scope="scope">
                                        <span v-if="item.type != 1">{{scope.row[item.prop]}}{{item.unit?item.unit:''}}</span>
                                        <span v-if="item.prop == 'TVOC'">{{tvocArr[scope.row[item.prop]]}}</span>

                                        <div v-if="item.prop == 'online'" class="online">
                                            <i v-if="scope.row.blueStatus=='0'" class="iconfont icon-lanyax" style="color:rgba(163,175,187,1);"></i>
                                            <i v-if="scope.row.blueStatus=='1'" class="iconfont icon-lanyax" :style="{'color': version=='0'?'rgba(5, 207, 171, 1)':'#8266C7'}"></i>
                                            <span>|</span>
                                            <i v-if="scope.row.online=='0'" class="iconfont icon-disconnect" style="color:rgba(163,175,187,1);"></i>
                                            <i v-if="scope.row.online=='1'" class="iconfont icon-connectx" :style="{'color': version=='0'?'rgba(5, 207, 171, 1)':'#8266C7'}"></i>
                                        </div>
                                        <div v-if="item.prop == 'status'" class="open" v-loading="scope.row.statusLoading">
                                            <span class="pl_switch" :class="{'checked':scope.row['status'] === 1}" @click="plSwitchFun(scope.row)"></span>
                                        </div>
                                        <div v-if="item.prop == 'level'" class="level" v-loading="scope.row.statusLoading">
                                            <el-dropdown @command="handleCommand" trigger="click" @visible-change="commandHide('dropdown_air_openType')">
                                                <span class="span1">{{levelArr[scope.row['level']-1]}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                                                <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_air_openType">
                                                    <el-dropdown-item v-for="(item,index) in levelArr" :key="item" :command="{data:scope.row,val:index+1}" :class="{'select':scope.row.level==index+1}">{{item}}</el-dropdown-item>
                                                </el-dropdown-menu>
                                            </el-dropdown>
                                            <span class="disabled" v-if="scope.row.status == '0'"></span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                align="center"
                                :width="role == 1?16*remRatio:14*remRatio"
                                :label="$t('App.lights.text6')">
                                <template slot-scope="scope">
                                    <span class="btn" @click="editFun(scope.row)" :title="$t('App.lights.text7')">
                                        <i class="iconfont icon-bianji"></i>
                                    </span>
                                    <span class="btn" @click="settingFun(scope.row)" :title="$t('App.airPurifiers.text1')">
                                        <i class="iconfont icon-Centralizedsetting"></i>
                                    </span>
                                    <span class="btn" @click="clean_time(scope.row)" :title="$t('App.airPurifiers.text21')" v-loading="scope.row.clean_timeLoading">
                                        <i class="iconfont icon-guiling"></i>
                                    </span>

                                    <span class="btn" @click="historySee(scope.row)" :title="$t('App.lights.text8')">
                                        <i class="iconfont icon-history"></i>
                                    </span>
                                    <span class="btn" @click="upgradeFun(scope.row)" :title="$t('App.lights.text9')">
                                        <i class="iconfont icon-gujianbanbenshengji"></i>
                                    </span>
                                    <span class="btn" @click="postDelLight(scope.row,false,0)" :title="$t('App.lights.text1')">
                                        <i class="iconfont icon-delete"></i>
                                    </span>
                                    <span v-if="role == 1" class="btn" @click="postDelLight(scope.row,false,1)" :title="$t('App.lights.text1')">
                                        <i class="iconfont icon-delete" style="color: red"></i>
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-checkbox-group>
                    <div class="pagination_box">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <!--  -->
        <div class="purifier_wrap scrollbar_style" v-show="purifierTkShowbg">
            <div class="purifier_wrap_bg" @click="purifierTkClose()"></div>
            <div class="purifier_box" :class="{'purifier_tk_show':purifierTkShow}">
                <div class="purifier_title">
                    <span class="span1">{{purifierTkTitle}}</span>
                    <span class="span2" @click="purifierTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="form">
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text42')}}</span>
                        <el-input v-model="purifierForm.name" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room_light.text57')}}</span>
                        <el-dropdown @command="commandModel" trigger="click" @visible-change="commandHide('dropdown_lights_model')">
                            <span class="span1">{{purifierFormModelName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_lights_model">
                                <el-dropdown-item v-for="item in modelNav" :command="item" :key="'floor'+item.id" :class="{'select':item.id==purifierForm.model}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text43')}}</span>
                        <el-input v-model="purifierForm.deviceId" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room_light.text58')}}</span>
                        <el-input v-model="purifierForm.gatewayId" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text29')}}</span>
                        <el-dropdown @command="commandFloor" trigger="click" @visible-change="commandHide('dropdown_air_floor')">
                            <span class="span1">{{purifierFormFloorName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_air_floor">
                                <el-dropdown-item v-for="item in floorNav" :command="item" :key="'floor'+item.id" :class="{'select':item.id==purifierForm.floorId}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text30')}}</span>
                        <el-dropdown @command="commandRoom" trigger="click" @visible-change="commandHide('dropdown_air_room')">
                            <span class="span1">{{purifierFormRoomName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_air_room">
                                <el-dropdown-item v-for="item in roomNav" :command="item" :key="'room'+item.id" :class="{'select':item.id==purifierForm.roomId}">{{item.number}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="postSavepurifier('0')">{{$t('App.room.text35')}}</div>
                </div>
            </div>
        </div>
        <!-- 历史数据 -->
        <div class="history_warp scrollbar_style" v-show="historyShowbg">
            <div class="history_warp_bg" @click="historyClose()"></div>
            <div class="history_box" :class="{'history_show':historyShow}">
                <div class="history_top">
                    <span class="span1">{{$t('App.room_light.text8')}}</span>
                    <span class="span2" @click="historyClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="filter_box">
                    <el-select v-model="chartType" placeholder=" " @change="chartTypeChange(chartType)" v-if="networHistoryType == '1'">
                        <el-option
                          v-for="item in chartTypeArr"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                    </el-select>
                    <el-select v-model="timeType2" placeholder=" " @change="timeType2Change(timeType2)">
                        <el-option
                          v-for="item in timeTypeArr"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                    </el-select>
                </div>

                <div class="table_top_box">
                    <div class="box1">
                       <div class="btn" :class="{'select':networHistoryType == '1'}" @click="networHistoryTypeFun('1')">{{$t('App.lights.text15')}}</div>
                       <div class="btn" :class="{'select':networHistoryType == '2'}" @click="networHistoryTypeFun('2')">{{$t('App.lights.text16')}}</div>
                    </div>
                    <div class="download_btn" @click="purifierLogList(purifierId,timeType2,1)" v-loading="loading.lightDataList2_csv">{{$t('App.lights.text17')}}</div>
                </div>
                <div class="echarts_warp scrollbar_style" v-if="networHistoryType == '1'">
                    <div class="echarts_box echarts_box1">
                        <div class="echarts_top">{{$t('App.airPurifiers.text2')}}</div>
                        <div class="history_echarts_box1"></div>
                    </div>
                    <div class="echarts_box echarts_box2">
                        <div class="echarts_top">{{$t('App.airPurifiers.text3')}}</div>
                        <div class="history_echarts_box2"></div>
                    </div>
                </div>
                <div class="table_box" v-if="networHistoryType == '2'">
                    <el-table
                        ref="purifierDataList2"
                        v-loading="loading.purifierDataList2"
                        element-loading-background="rgba(0, 0, 0, 0.5)"
                        height="100%"
                        :data="purifierDataList2">
                        <el-table-column
                            :label="$t('App.lights.text33')"
                            :prop="'webIndex'"
                            align="center"
                            header-align="center"
                            :width="6*remRatio">
                        </el-table-column>
                        <el-table-column
                            v-for="(item) in lightArr2"
                            :key="'table_'+item.prop"
                            :prop="item.prop"
                            :label="item.label"
                            :align="item.align?item.align:'center'"
                            :width="item.width"
                            :show-overflow-tooltip="true"
                            :min-width="item.minWidth">
                            <template slot-scope="scope">
                                <span v-if="item.type != 1">{{scope.row[item.prop]}}{{item.unit?item.unit:''}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination_box">
                        <el-pagination
                            @size-change="handleSizeChange2"
                            @current-change="handleCurrentChange2"
                            :current-page="currentPage2"
                            :page-size="pageSize2"
                            layout="prev, pager, next"
                            :total="total2">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <!--  -->
        <div class="purifierSetting_wrap scrollbar_style" v-show="purifierSettingTkShowbg">
            <div class="purifierSetting_wrap_bg" @click="purifierSettingTkClose()"></div>
            <div class="purifierSetting_box" :class="{'purifierSetting_tk_show':purifierSettingTkShow}">
                <div class="purifierSetting_title">
                    <span class="span1">{{purifierSettingTkTitle}}</span>
                    <span class="span2" @click="purifierSettingTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="form">
                    <div class="form_item">
                        <span class="laber">{{$t('App.airPurifiers.text3')}}</span>
                        <el-input-number v-model="purifierFormNew.uTime" :controls="false" :min="0" :precision="0"></el-input-number>
                        <span class="unit">{{$t('App.airPurifiers.text5')}}</span>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.airPurifiers.text4')}}</span>
                        <el-dropdown @command="commandPurifierSetting" trigger="click" @visible-change="commandHide('dropdown_air_floor')">
                            <span class="span1">{{purifierSettingFormPurModel}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_air_floor">
                                <el-dropdown-item v-for="item in purModelArr" :command="item" :key="'floor'+item.id" :class="{'select':item.id==purifierFormNew.purModel}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item" v-if="purifierFormNew.purModel != '0'">
                        <span class="laber">{{$t('App.airPurifiers.text17')}}</span>
                        <el-time-picker
                            v-model="purifierFormNew.startTime"
                            format="HH:mm"
                            value-format="HH:mm">
                        </el-time-picker>
                    </div>
                    <div class="form_item" v-if="purifierFormNew.purModel != '0'">
                        <span class="laber">{{$t('App.airPurifiers.text18')}}</span>
                        <el-time-picker
                            v-model="purifierFormNew.endTime"
                            format="HH:mm"
                            value-format="HH:mm">
                        </el-time-picker>
                    </div>
                    <div class="form_item" v-if="purifierFormNew.purModel != '0'">
                        <span class="laber">{{$t('App.airPurifiers.text22')}}</span>
                         <el-input-number v-model="purifierFormNew.delayTime" :controls="false" :min="10" :max="3600"></el-input-number>
                        <span class="unit">(s)</span>
                    </div>
                    <div class="form_item1" v-if="purifierFormNew.purModel != '0'">
                        <p class="laber label_t">{{$t('App.airPurifiers.text20')}}</p>
                        <div class="table">
                            <div class="tr">
                                <div class="th w_1"></div>
                                <div class="th w_2">{{$t('App.airPurifiers.text7')}}</div>
                                <div class="th w_2">{{$t('App.airPurifiers.text9')}}</div>
                                <div class="th w_2">{{$t('App.airPurifiers.text10')}}</div>
                                <div class="th w_4 text-right">{{$t('App.airPurifiers.text11')}}</div>
                                <!-- <div class="th w_4"></div> -->
                            </div>
                            <div class="tr">
                                <div class="td w_2">
                                    <span class="text">PM2.5(µg/m³)</span>
                                    <span class="tips">or</span>
                                </div>
                                <div class="td w_2">
                                    <el-input-number v-model="purifierFormNew.pm25_level1" :controls="false" :min="0" :precision="0"></el-input-number>
                                </div>
                                <div class="td w_2">
                                    <el-input-number v-model="purifierFormNew.pm25_level2" :controls="false" :min="0" :precision="0"></el-input-number>
                                </div>
                                <div class="td w_2">
                                    <el-input-number v-model="purifierFormNew.pm25_level3" :controls="false" :min="0" :precision="0"></el-input-number>
                                </div>
                                <div class="td w_3"></div>
                            </div>
                            <div class="tr" v-if="purifierFormNew.purModel == '1'">
                                <div class="td w_2">
                                    <span class="text">PM10(µg/m³)</span>
                                    <span class="tips">or</span>
                                </div>
                                <div class="td w_2">
                                    <el-input-number v-model="purifierFormNew.pm10_level1" :controls="false" :min="0" :precision="0"></el-input-number>
                                </div>
                                <div class="td w_2">
                                    <el-input-number v-model="purifierFormNew.pm10_level2" :controls="false" :min="0" :precision="0"></el-input-number>
                                </div>
                                <div class="td w_2">
                                    <el-input-number v-model="purifierFormNew.pm10_level3" :controls="false" :min="0" :precision="0"></el-input-number>
                                </div>
                                <div class="td w_3"></div>
                            </div>
                            <div class="tr" v-if="purifierFormNew.purModel == '1'">
                                <div class="td w_2">
                                    <span class="text">CO₂(ppm)</span>
                                    <span class="tips">or</span>
                                </div>
                                <div class="td w_2">
                                    <el-input-number v-model="purifierFormNew.co2_level1" :controls="false" :min="0" :precision="0"></el-input-number>
                                </div>
                                <div class="td w_2">
                                    <el-input-number v-model="purifierFormNew.co2_level2" :controls="false" :min="0" :precision="0"></el-input-number>
                                </div>
                                <div class="td w_2">
                                    <el-input-number v-model="purifierFormNew.co2_level3" :controls="false" :min="0" :precision="0"></el-input-number>
                                </div>
                                <div class="td w_3"></div>
                            </div>
                            <div class="tr">
                                <div class="td w_2">
                                    <span class="text">TVOC(ppb)</span>
                                    <span class="tips" v-if="purifierFormNew.purModel == '1'">or</span>
                                </div>
                                <div class="td w_2" v-if="purifierFormNew.purModel == '2'">
                                    <el-select v-model="purifierFormNew.tvoc_level0" placeholder="" @change="tvoc_level0Fun">
                                        <el-option
                                          v-for="item in levelArrObjNew"
                                          :key="item.id"
                                          :label="item.name"
                                          :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="td w_2">
                                    <el-input-number v-model="purifierFormNew.tvoc_level1" :controls="false" :min="0" :precision="0" v-if="purifierFormNew.purModel == '1'"></el-input-number>
                                    <el-select v-model="purifierFormNew.tvoc_level1" placeholder=""  v-if="purifierFormNew.purModel == '2'" @change="tvoc_level1Fun">
                                        <el-option
                                          v-for="item in levelArrObjNew"
                                          :key="item.id"
                                          :label="item.name"
                                          :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="td w_2">
                                    <el-input-number v-model="purifierFormNew.tvoc_level2" :controls="false" :min="0" :precision="0" v-if="purifierFormNew.purModel == '1'"></el-input-number>
                                    <el-select v-model="purifierFormNew.tvoc_level2" placeholder=""  v-if="purifierFormNew.purModel == '2'">
                                        <el-option
                                          v-for="item in levelArrObj"
                                          :key="item.id"
                                          :label="item.name"
                                          :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="td w_2">
                                    <el-input-number v-model="purifierFormNew.tvoc_level3" :controls="false" :min="0" :precision="0" v-if="purifierFormNew.purModel == '1'"></el-input-number>
                                    <el-select v-model="purifierFormNew.tvoc_level3" placeholder=""  v-if="purifierFormNew.purModel == '2'">
                                        <el-option
                                          v-for="item in levelArrObj"
                                          :key="item.id"
                                          :label="item.name"
                                          :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="td" :class="purifierFormNew.purModel == '2'?'w_5':'w_3'"></div>
                            </div>
                            <div class="tr" v-if="purifierFormNew.purModel == '1'">
                                <div class="td w_2">
                                    <span class="text">{{$t('App.dashboard.text13')}}(ppb)</span>
                                    <!-- <span class="tips">or</span> -->
                                </div>
                                <div class="td w_2">
                                    <el-input-number v-model="purifierFormNew.hcho_level1" :controls="false" :min="0" :precision="0"></el-input-number>
                                </div>
                                <div class="td w_2">
                                    <el-input-number v-model="purifierFormNew.hcho_level2" :controls="false" :min="0" :precision="0"></el-input-number>
                                </div>
                                <div class="td w_2">
                                    <el-input-number v-model="purifierFormNew.hcho_level3" :controls="false" :min="0" :precision="0"></el-input-number>
                                </div>
                                <div class="td w_3"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="postSavepurifier('1')">{{$t('App.room.text35')}}</div>
                </div>
            </div>
        </div>

        <!-- 网关升级 -->
        <div class="gatewayUpdate_wrap scrollbar_style" v-show="gatewayUpdateTkShowbg">
            <div class="gatewayUpdate_wrap_bg" @click="gatewayUpdateTkClose()"></div>
            <div class="gatewayUpdate_box" :class="{'gateway_tk_show':gatewayUpdateTkShow}">
                <div class="gatewayUpdate_title">
                    <span class="span1">{{$t('App.lights.text20')}}</span>
                    <span class="span2" @click="gatewayUpdateTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="box1">
                   <div><img src="../img/upgrade.png"></div>
                   <div><span>{{gatewayUpdateSoftware}}</span></div>
                </div>
                <p class="p1">{{$t('App.lights.text21')}}</p>
                <div class="btn_box">
                    <div class="btn" v-if="gatewayUpdateType == '1'" @click="gatewayUpdateFun()">{{'Download '+gatewayUpdateVersion}}</div>
                    <el-progress :stroke-width="null" :percentage="uploadGatewayVal" :text-inside="true" v-if="gatewayUpdateType == '2'" v-loading="gatewayUpdateType =='2'"></el-progress>
                    <div class="text" :class="gatewayUpdateStatus=='0'?'span1':'span2'" v-if="gatewayUpdateType == '3'" @click="gatewayUpdateFun()">
                        <span v-if="gatewayUpdateStatus == '0'" class="span1">{{$t('App.lights.text22')}}</span>
                        <span v-if="gatewayUpdateStatus == '1'" class="span2">{{$t('App.lights.text23')}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    // import sideBar from '../components/sideBar.vue'
    import { mapGetters } from 'vuex'
    import allUrl from '../api/allUrl.js'
    import base from '../api/base.js'
    export default {
        name:'airPurifiers',
        data () {
            return{
                buildId:'',
                buildNav:[],
                keywords:'',
                floorNav:[],
                roomNav:[],

                checkAll:false,
                isIndeterminate:false,
                checkList:[],

                lightArr:[],
                purifierDataList:[],
                purifierDataIdList:[],
                onlineArr:['Off-line','On-line'],
                levelArr:['Low','Middle','High'],
                levelArrObj:[{id:1,name:'Low'},{id:2,name:'Middle'},{id:3,name:'High'}],
                levelArrObjNew:[{id:0,name:'Null'},{id:1,name:'Low'},{id:2,name:'Middle'},{id:3,name:'High'}],
                tvocArr:['level1','level2','level3'],
                level_:'',
                status_:'',

                currentPage:1,
                pageSize:20,
                total:1000,

                purifierTkShowbg:false,
                purifierTkShow:false,
                purifierForm:{
                    name:'',
                    model:'',
                    deviceId:'',
                    floorId:'',
                    roomId:'',
                    gatewayId:'',
                    shutStart:null,
                    shutStop:null,
                    lowStart:null,
                    lowStop:null,
                    midStart:null,
                    midStop:null,
                    highStart:null,
                    highStop:null,
                    // type:'0',
                },
                purifierFormNew:{
                    uTime:null,
                    purModel:'0',
                    startTime:'',
                    endTime:'',
                    delayTime:'',
                    pm25_level1:'',
                    pm25_level2:'',
                    pm25_level3:'',
                    pm10_level1:'',
                    pm10_level2:'',
                    pm10_level3:'',
                    co2_level1:'',
                    co2_level2:'',
                    co2_level3:'',

                    tvoc_level0:'0',
                    tvoc_level1:'0',
                    tvoc_level2:'0',
                    tvoc_level3:'0',

                    tvoc_level1_:'0',
                    tvoc_level2_:'0',
                    tvoc_level3_:'0',

                    hcho_level1:'',
                    hcho_level2:'',
                    hcho_level3:'',
                },
                purifierFormFloorName:'',
                purifierFormRoomName:'',
                purifierTkTitle:'',
                modelNav:[],

                historyShowbg:false,
                historyShow:false,
                networHistoryType:'1',
                chartType:'0',
                chartTypeStr:'line',
                chartTypeArr:[{label:'Line',value:'0',str:'line'},{label:'Bar',value:'1',str:'bar'}],
                timeType1:'0',
                timeType2:'0',
                timeTypeStr:'Daily',
                timeTypeArr:[{label:'Daily',value:'0'},{label:'Weekly',value:'4'},{label:'Monthly',value:'1'},{label:'Yearly',value:'2'}],

                purifierDataList2:[],
                lightArr2:[],

                currentPage2:1,
                pageSize2:20,
                total2:0,

                reDataIndex:0,

                purifierSettingTkShowbg:false,
                purifierSettingTkShow:false,
                purifierSettingTkTitle:'Setting',
                // purifierSettingForm:{
                //     uTime:0,
                //     purModel:'0',
                // },
                purModelArr:[{id:'0',name:'Manual mode'},{id:'1',name:'Auto mode'}],

                gatewayUpdateTkShowbg:false,
                gatewayUpdateTkShow:false,
                uploadGatewayVal:0,
                gatewayUpdateType:'1',
                gatewayUpdateSoftware:'',
                gatewayUpdateVersion:'',
                gatewayUpdateStatus:'1',

                loading:{
                    purifierDataList:false,
                    purifierDataList2:false,
                    purifierDataList2_csv:false,
                },

                img_lights_3:'',
                updateRemRatioShakeProof:null,

                delDelIs_true:false,
            }
        },
        computed:{
            ...mapGetters({
                token:'token',
                client_key:'client_key',
                username:'username',
                version:'version',
                role:'role',

                remRatio:'remRatio',
                updateRemRatio:'updateRemRatio',

                countryId:'countryId',
                provinceId:'provinceId',
                cityId:'cityId',
                hotelId:'hotelId',
                headerIdStr:'headerIdStr',
            }),
            purifierSettingFormPurModel(){
                let name = '';
                for(let d of this.purModelArr){
                    if(d.id == this.purifierFormNew.purModel){
                        name = d.name
                    }
                }
                return name
            },
            purifierFormModelName(){
                let name = '';
                for(let d of this.modelNav){
                    if(d.id == this.purifierForm.model){
                        name = d.name
                    }
                }
                return name
            }
        },
        components:{
            // 'sideBar':sideBar
        },
        beforeDestroy(){
            if(this.websocket){
                this.websocket.close();
            }
        },
        mounted(){
            this.img_lights_3 = require('../img/room/map/lights_3.png');

            if(this.version == '1'){
                this.img_lights_3 = require('../img/room/map/lights_3_v1.png');
            }

            this.alertsArr = [this.$t('App.room_light.text59'),this.$t('App.room_light.text60')];
            this.onlineArr = [this.$t('App.room.text65'),this.$t('App.room.text66')];
            this.levelArr = [this.$t('App.room.text68'),this.$t('App.room.text69'),this.$t('App.room.text70')];
            this.tvocArr = [this.$t('App.room.text68'),this.$t('App.room.text69'),this.$t('App.room.text70')];
            this.levelArrObj = [{id:'1',name:this.$t('App.room.text68')},{id:'2',name:this.$t('App.room.text69')},{id:'3',name:this.$t('App.room.text70')}];
            this.levelArrObjNew = [{id:'0',name:this.$t('App.room.text67_')},{id:'1',name:this.$t('App.room.text68')},{id:'2',name:this.$t('App.room.text69')},{id:'3',name:this.$t('App.room.text70')}];

            
            this.chartTypeArr = [{label:this.$t('App.room_light.text61'),value:'0',str:'line'},{label:this.$t('App.room_light.text62'),value:'1',str:'bar'}];

            this.timeTypeStr = this.$t('App.room_light.text63');
            this.timeTypeArr = [{label:this.$t('App.room_light.text63'),value:'0'},{label:this.$t('App.room_light.text64'),value:'4'},{label:this.$t('App.room_light.text65'),value:'1'},{label:this.$t('App.room_light.text66'),value:'2'}];

            this.purifierSettingTkTitle = this.$t('App.airPurifiers.text1');

            this.purModelArr = [{id:'0',name:this.$t('App.airPurifiers.text12')},{id:'1',name:this.$t('App.airPurifiers.text13')},{id:'2',name:this.$t('App.airPurifiers.text24')}];

            this.$store.commit('SIDEBARSHOW',{
                sideBarShow:true,
            })
            for(let i = 1;i<4;i++){
                let val = i<10?'0'+i:i;
                let id = i - 1;
                this.$set(this.modelNav,this.modelNav.length,{id:id,name:'IH-AP'+val})
            }
            this.lightArr = [
                {prop:'floor',label:this.$t('App.room.text29'),minWidth:5*this.remRatio},
                {prop:'roomNumber',label:this.$t('App.room.text30'),minWidth:5*this.remRatio},
                {prop:'status',label:this.$t('App.room_light.text46'),minWidth:5*this.remRatio,type:1,align:'left'},
                {prop:'level',label:this.$t('App.airPurifiers.text6'),minWidth:6*this.remRatio,type:1,align:'left'},

                {prop:'pm25',label:'PM2.5',minWidth:5*this.remRatio,unit:'ug/m³'},
                {prop:'TVOC',label:'TVOC',minWidth:5*this.remRatio,unit:'ppb',type:1},

                {prop:'workTime',label:this.$t('App.airPurifiers.text2'),minWidth:13.5*this.remRatio,unit:'h'},
                {prop:'useTime',label:this.$t('App.airPurifiers.text3'),minWidth:12*this.remRatio,unit:'h'},
                {prop:'online',label:this.$t('App.lights.text30'),minWidth:8*this.remRatio,type:1},
                {prop:'updateTime',label:this.$t('App.lights.text32'),width:11.5*this.remRatio},
            ];
            this.lightArr2 = [
                {prop:'workTime',label:this.$t('App.airPurifiers.text2'),minWidth:13.5*this.remRatio},
                {prop:'useTime',label:this.$t('App.airPurifiers.text3'),minWidth:14*this.remRatio},
                {prop:'updateTime',label:this.$t('App.lights.text32'),width:14*this.remRatio},
            ];
            this.getBuildNav(()=>{
                if(this.buildNav.length > 0){
                    this.buildId = this.buildNav[0].id;
                }else{
                    this.buildId = '';
                }
                this.getPurifierList();
            });
            base.websocket_close(allUrl.websocket.ws,websocket=>{
                // console.log(websocket)
                this.websocket = websocket;
                this.websocket.send('{"type":"cmd"}');
                websocket.onmessage = event => {
                    console.log(JSON.parse(event.data));
                    let data = JSON.parse(event.data)
                    if(data.code == '0000'){
                        if(data.data.status == '1'){
                            this.clientid = data.data.clientid
                        }
                        if(data.data.status == '2'){
                            this.$notify({
                                title: data.msg,
                                message: this.$t('App.message.text21')+data.data.name,
                                type: 'success'
                            });
                            if(data.data.type == 'delete'){
                                this.getPurifierList();
                            }
                            if(data.data.type == 'trun_off'){
                                for(let d of this.purifierDataList){
                                    if(d.id == data.data.id){
                                        d.statusLoading = false;
                                    }
                                }
                            }
                            if(data.data.type == 'ref_data'){
                                this.reDataIndex--;
                                if(this.reDataIndex<0){
                                    this.reDataIndex = 0;
                                }
                                this.getPurifierList();
                            }
                        }
                    }else{
                        this.$alert(data.msg, this.$t('App.message.text1'), {
                            confirmButtonText: this.$t('App.message.text2'),
                        });
                        if(data.data.type == 'trun_off'){
                            for(let d of this.purifierDataList){
                                if(d.id == data.data.id){
                                    d.statusLoading = false;
                                    d.status = this.status_;
                                    d.level = this.level_;
                                }
                            }
                        }
                            
                    }
                }
            },this)

        },
        methods:{
            tvoc_level0Fun(val){
                if(val != 0){
                    this.purifierFormNew.tvoc_level1 = '0'
                }
            },
            tvoc_level1Fun(val){
                if(val != 0){
                    this.purifierFormNew.tvoc_level0 = '0'
                }
            },
            gatewayUpdateTkClose(){
                let this_ = this;
                this.gatewayUpdateTkShow = false;
                setTimeout(function(){
                    this_.gatewayUpdateTkShowbg = false;
                },400)
            },
            gatewayUpdateFun(){
                if(this.gatewayUpdateStatus == '1'||this.gatewayUpdateType == '2'){
                    base.websocket(allUrl.websocket.ws,websocket=>{
                        this.websocket1 = websocket;
                        websocket.send('{"type":"updateNetwork","id":"'+this.purifierId+'"}');
                        websocket.onmessage = event => {
                            // console.log(JSON.parse(event.data));
                            let data = JSON.parse(event.data)
                            if(data.code == '0000'){
                                if(data.data.status == '1'){
                                    this.clientid = data.data.clientid
                                    base.ajax_postWs(
                                        allUrl.gateway.updateFire,
                                        {
                                            username:this.username,
                                            client_key:this.client_key,
                                            token:this.token,
                                            id:this.purifierId,
                                            type:'3',
                                            clientId:this.clientid,
                                        },
                                        this
                                    )
                                    this.uploadGatewayVal = 0;
                                    this.gatewayUpdateType = '2';
                                }
                                if(data.data.status == '2'){
                                    if(data.data.type == 'updateNetwork'){
                                        this.uploadGatewayVal = data.data.step;
                                        if(this.uploadGatewayVal>=100){
                                            this.gatewayUpdateType = '3';
                                            this.gatewayUpdateStatus = '1';
                                        }
                                    }
                                }
                            }else{
                                this.$alert(data.msg, this.$t('App.message.text1'), {
                                    confirmButtonText: this.$t('App.message.text2'),
                                });
                                if(data.data.status == '2'){
                                    if(data.data.type == 'updateNetwork'){
                                        this.uploadGatewayVal = 0;
                                        this.gatewayUpdateType = '3';
                                        this.gatewayUpdateStatus = '0';
                                    }
                                }
                            }
                        }
                    })
                }
            },
            upgradeFun(obj){
                // if(obj.model == '4'||obj.model == '5'||obj.model == '6'){
                //     this.$notify({
                //         message: 'Cannot upgrade',
                //         type: 'warning'
                //     });
                //     return
                // }
                if(obj.online == 0){
                    this.$notify({
                        message: this.$t('App.message.text9'),
                        type: 'warning'
                    });
                    return
                }
                this.gatewayUpdateTkShowbg = true;
                this.gatewayUpdateSoftware = obj.software;
                this.purifierId = obj.id;

                this.gatewayUpdateType = '1';
                this.gatewayUpdateStatus = '1';
                base.ajax_post(
                    allUrl.gateway.checkUpdate,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        id:obj.id,
                        type:'1',
                    },
                    {},
                    data=>{
                        if(data.data.status == '1'){
                            this.gatewayUpdateTkShow = true;
                            this.gatewayUpdateVersion = data.data.version
                        }else{
                            this.gatewayUpdateTkShowbg = false;
                            this.$notify({
                                message: data.data.version+this.$t('App.message.text10'),
                                type: 'success'
                            });
                        }
                    },
                    this,()=>{
                        this.gatewayUpdateTkShowbg = false;
                    }
                )
            },

            chartTypeChange(){
                for(let d of this.chartTypeArr){
                    if(d.value == this.chartType){
                        this.chartTypeStr = d.str
                    }
                }
                this.getPurifierReport(this.timeType2,data=>{
                    this.echartsFun({dataList:data.data.workTimeList,timeList:data.data.timeList},this.chartTypeStr,'rgba(5,206,171,1)','history_echarts_box1','h');
                    this.echartsFun({dataList:data.data.userTimeList,timeList:data.data.timeList},this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box2','h');
                })
            },
            timeType2Change(){
                if(this.networHistoryType == '1'){
                    this.getPurifierReport(this.timeType2,data=>{
                        this.echartsFun({dataList:data.data.workTimeList,timeList:data.data.timeList},this.chartTypeStr,'rgba(5,206,171,1)','history_echarts_box1','h');
                        this.echartsFun({dataList:data.data.userTimeList,timeList:data.data.timeList},this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box2','h');
                    })
                }
                else{
                    this.purifierLogList(this.purifierId,this.timeType2,0)
                }
            },
            networHistoryTypeFun(val){
                this.networHistoryType = val;
                if(this.networHistoryType == '1'){
                    this.getPurifierReport(this.timeType2,data=>{
                        this.echartsFun({dataList:data.data.workTimeList,timeList:data.data.timeList},this.chartTypeStr,'rgba(5,206,171,1)','history_echarts_box1','h');
                        this.echartsFun({dataList:data.data.userTimeList,timeList:data.data.timeList},this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box2','h');
                    })
                }
                else{
                    this.purifierLogList(this.purifierId,this.timeType2,0)
                }
            },
            /*空气净化器设备日志信息*/
            getPurifierReport(timeType,callback){
                base.ajax_post(
                    allUrl.roomLight.purifierReport,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        purifierId:this.purifierId,
                        timeType:timeType,
                        dateType:this.timeType2,
                    },
                    {},
                    data=>{
                        this.purifierReport = data.data;
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            echartsFun(data,type,color,className,unit){
                console.log(data,className)
                this.myChart2 = this.$echarts.init(document.getElementsByClassName(className)[0]);
                this.myChart2.setOption({
                    tooltip:{
                        trigger:'axis',
                        axisPointer:{
                            type : type=='bar'?'shadow':'line',
                            snap:true,
                        },
                        padding:0,
                        formatter: function (params) {
                            // console.log(params)
                            var tls = `<div class="history_echarts_tooltip"><p class="p1"><i style="background-color:${params[0].color}"></i><span class="span1">${params[0].value}</span><span class="span1">${unit}</span></p><p class="p2">${params[0].name}</p></div>`;
                           return tls;
                        },
                    },
                    grid:{
                        top:10,
                        left:40,
                        right:50,
                        bottom:40,
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: type=='bar'?true:false,
                        data: data.timeList,
                        axisTick:{
                            show:false,
                            alignWithLabel: true
                        },
                        axisLine:{
                            show:false
                        },
                        axisLabel:{
                            color:'rgba(163,175,187,1)',
                            fontStyle:'AlibabaPuHuiTiR',
                            fontSize:'1rem',
                        },
                    },
                    yAxis: {
                        type: 'value',
                        nameGap:6,
                        splitNumber:4,
                        axisTick:{
                            show:false,
                        },
                        axisLine:{
                            show:false
                        },
                        splitLine:{
                            lineStyle:{
                                color:'rgba(235,239,242,1)'
                            }
                        },
                        axisLabel:{
                            color:'rgba(163,175,187,1)',
                            fontStyle:'AlibabaPuHuiTiR',
                            fontSize:'1rem',
                        },
                    },
                    series: [{
                        data: data.dataList,
                        type: type,
                        smooth:true,
                        barWidth:type=='bar'?'50%':null,
                        symbol:type=='line'?'none':false,
                        lineStyle:{
                            color:color,
                        },
                        itemStyle:{
                            color:color,
                        },
                        markLine:{
                            data:type=='line'?[{type:'average',name:'平均值'}]:null,
                            lineStyle:{
                                color:'rgba(5,206,171,0.4)',
                                type:'dotted',
                            }
                        }
                    }]
                });
            },
            purifierLogList(devId,dateType,download){
                if(download == '1'){
                    this.loading.purifierDataList2_csv = true;
                }else{
                    this.loading.purifierDataList2 = true;
                }
                base.ajax_post(
                    allUrl.roomLight.purifierLogList,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,

                        purifierId:devId,
                        page:this.currentPage2,
                        count:this.pageSize2,
                        dateType:dateType,
                        // date:date,
                        download:download,
                    },
                    {},
                    data=>{
                        if(download == '1'){
                            this.loading.purifierDataList2_csv = false;
                            // var $eleBtn2 = $("#btn2");
                            var $eleForm = $("<form method='get'></form>");
                            $eleForm.attr("action",data.data.url);
                            $(document.body).append($eleForm);
                            //提交表单，实现下载
                            $eleForm.submit();
                        }else{
                            this.loading.purifierDataList2 = false;
                            this.purifierDataList2 = data.data.list;
                            this.total2 = Number(data.data.total);

                            let i = 1 + (this.currentPage2-1)*this.pageSize2;
                            for(let d of this.purifierDataList2){
                                d.webIndex = i;
                                i++;
                            }
                        }
                    },
                    this,()=>{
                        if(download == '1'){
                            this.loading.purifierDataList2_csv = false;
                        }else{
                            this.loading.purifierDataList2 = false;
                        }
                    }
                )
            },
            historyClose(){
                let this_ = this;
                this.historyShow = false;
                setTimeout(function(){
                    this_.historyShowbg = false;
                },400)
            },
            historySee(obj){
                this.purifierId = obj.id;
                this.historyShowbg = true;
                this.$nextTick(function(){
                    this.historyShow = true;
                    this.networHistoryType = '1';
                    this.getPurifierReport(this.timeType2,data=>{
                        this.echartsFun({dataList:data.data.workTimeList,timeList:data.data.timeList},this.chartTypeStr,'rgba(5,206,171,1)','history_echarts_box1','h');
                        this.echartsFun({dataList:data.data.userTimeList,timeList:data.data.timeList},this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box2','h');
                    })
                })
            },

            commandHide(val){
                this.$nextTick(function(){
                    if($('.'+val)&&$('.'+val+' >.select').offset()){
                        $('.'+val).animate({scrollTop: $('.'+val).scrollTop() + $('.'+val+' >.select').offset().top - $('.'+val).offset().top - 100})
                    }
                })
            },
            settingFun(item){
                console.log(item)
                this.purifierSettingTkShowbg = true;
                this.$nextTick(function(){
                    this.purifierSettingTkShow = true;
                })
                this.purifierId = item.id;
                this.get_mode_and_time(this.purifierId,data=>{
                    for(let key in data.data){
                        this.purifierFormNew[key] = data.data[key];
                    }
                    
                })
            },
            get_mode_and_time(id,callback){
                base.ajax_post(
                    allUrl.roomLight.get_mode_and_time,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        purifierId:id,
                    },
                    {},
                    data=>{
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            purifierSettingTkClose(){
                let this_ = this;
                this.purifierSettingTkShow = false;
                setTimeout(function(){
                    this_.purifierSettingTkShowbg = false;
                },400)
            },
            // purifierSettingPostSave(){
            //     let this_ = this;
            //     this.purifierSettingTkShow = false;
            //     setTimeout(function(){
            //         this_.purifierSettingTkShowbg = false;
            //     },400)
            // },
            commandPurifierSetting(data){
                this.purifierFormNew.purModel = data.id;
                if(this.purifierFormNew.purModel == '1'){
                    this.purifierFormNew.tvoc_level1 = 0;
                    this.purifierFormNew.tvoc_level2 = 0;
                    this.purifierFormNew.tvoc_level3 = 0;
                }else{
                    this.purifierFormNew.tvoc_level0 = '0';
                    this.purifierFormNew.tvoc_level1 = '1';
                    this.purifierFormNew.tvoc_level2 = '1';
                    this.purifierFormNew.tvoc_level3 = '1';
                }
            },

            getGatewayList(callback){
                if(this.buildId){
                    this.loading.gatewayDataList = true;
                    base.ajax_post(
                        allUrl.gateway.getlist,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            buildId:this.buildId,
                            // roomId:this.roomId,
                            page:1,
                            count:10,
                            type:'0',
                            // keywords:this.keywords,
                        },
                        {},
                        data=>{
                            if(callback){
                                callback(data)
                            }
                        },
                        this
                    )
                }
            },
            /*编辑设备*/
            editFun(item){
                this.purifierTkTitle = this.$t('App.airPurifiers.text14');
                this.purifierTkShowbg = true;
                for(let key in this.purifierForm){
                    this.purifierForm[key] = item[key];
                }
                if(!this.purifierForm.gatewayId){
                    this.purifierForm.gatewayId = '00000000'
                }
                this.purifierId = item.id;
                this.getFloorNav(()=>{
                    for(let d of this.floorNav){
                        if(d.id == this.purifierForm.floorId){
                            this.purifierFormFloorName = d.name;
                        }
                    }
                })
                this.getRoomNav(()=>{
                    for(let d of this.roomNav){
                        console.log(d,this.purifierForm.roomId)
                        if(d.id == this.purifierForm.roomId){
                            this.purifierFormRoomName = d.number;
                        }
                    }
                });
                this.$nextTick(function(){
                    this.purifierTkShow = true;
                })
            },
            /*添加设备*/
            addPurifierFun(){
                this.purifierTkTitle = this.$t('App.airPurifiers.text15');
                this.purifierTkShowbg = true;
                for(let key in this.purifierForm){
                    this.purifierForm[key] = '';
                }
                this.getGatewayList(data=>{
                    if(data.data.list.length>0){
                        this.purifierForm.gatewayId = data.data.list[0].gatewayId;
                    }
                })
                this.purifierFormFloorName = '';
                this.purifierFormRoomName = '';
                this.purifierId = '0';
                this.getFloorNav(()=>{
                    if(this.floorNav.length > 0){
                        this.purifierForm.floorId = this.floorNav[0].id;
                        for(let d of this.floorNav){
                            if(d.id == this.purifierForm.floorId){
                                this.purifierFormFloorName = d.name;
                            }
                        }
                        this.getRoomNav(()=>{
                            if(this.roomNav.length > 0){
                                this.purifierForm.roomId = this.roomNav[0].id;
                                for(let d of this.roomNav){
                                    if(d.id == this.purifierForm.roomId){
                                        this.purifierFormRoomName = d.number;
                                    }
                                }
                            }
                        });
                    }
                })
                this.$nextTick(function(){
                    this.purifierTkShow = true;
                })
            },
            purifierTkClose(){
                let this_ = this;
                this.purifierTkShow = false;
                setTimeout(function(){
                    this_.purifierTkShowbg = false;
                },400)
            },
            commandModel(data){
                this.purifierForm.model = data.id;
            },
            commandFloor(data){
                this.purifierForm.floorId = data.id;
                this.purifierFormFloorName = data.name;
                this.getRoomNav(()=>{
                    this.purifierForm.roomId = '';
                    this.purifierFormRoomName = ''
                });
                this.purifierForm.roomId = '';
            },
            commandRoom(data){
                this.purifierForm.roomId = data.id;
                this.purifierFormRoomName = data.number;
            },
            /*保存*/
            postSavepurifier(type){
                let this_ = this;
                let purifierFormNew;
                if(this.purifierFormNew.purModel == '0'){
                    purifierFormNew = {
                        uTime:this.purifierFormNew.uTime,
                        purModel:this.purifierFormNew.purModel
                    }
                }else{
                    purifierFormNew = {...this.purifierFormNew}
                }
                if(this.purifierFormNew.purModel == '2'){
                    purifierFormNew = {
                        uTime:this.purifierFormNew.uTime,
                        purModel:this.purifierFormNew.purModel,
                        pm25_level1_1:this.purifierFormNew.pm25_level1,
                        pm25_level2_1:this.purifierFormNew.pm25_level2,
                        pm25_level3_1:this.purifierFormNew.pm25_level3,
                        tvoc_level0_1:this.purifierFormNew.tvoc_level0,
                        tvoc_level1_1:this.purifierFormNew.tvoc_level1,
                        tvoc_level2_1:this.purifierFormNew.tvoc_level2,
                        tvoc_level3_1:this.purifierFormNew.tvoc_level3,
                    }
                }
                if(type == '0'){
                    base.ajax_post(
                        allUrl.roomLight.savePurifier,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            purifierId:this.purifierId,
                            ...this.purifierForm
                        },
                        {},
                        data=>{
                            this.purifierTkShow = false;
                            setTimeout(function(){
                                this_.purifierTkShowbg = false;
                            },400)
                        
                            this.getPurifierList();
                            this.$message({
                              showClose: true,
                              message: data.msg,
                              type: 'success'
                            });
                        },
                        this
                    )
                }
                if(type == '1'){
                    base.ajax_post(
                        allUrl.roomLight.set_mode_and_time,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            purifierId:this.purifierId,
                            ...purifierFormNew
                        },
                        {},
                        data=>{
                            this.purifierSettingTkShow = false;
                            setTimeout(function(){
                                this_.purifierSettingTkShowbg = false;
                            },400)

                            this.getPurifierList();
                            this.$message({
                              showClose: true,
                              message: data.msg,
                              type: 'success'
                            });
                        },
                        this
                    )
                }
            },
            /*设备数据刷新*/
            postReData(arr){
                if(this.reDataIndex>0){
                    return
                }
                let purifierId = '',isTrue = true;
                if(arr.length == 0){
                    isTrue = false;
                    this.$message({
                        message: this.$t('App.message.text11'),
                        type: 'warning'
                    });
                }else{
                    this.reDataIndex  = 0;
                    for(let id of arr){
                        if(purifierId == ''){
                            purifierId = id;
                        }else{
                            purifierId += ','+id;
                        }
                        this.reDataIndex++;
                    }
                }
                if(isTrue){
                    base.ajax_postWs(
                        allUrl.roomLight.reData,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            id:purifierId,
                            clientId:this.clientid,
                            type:3,
                        },
                        this
                    )
                }
            },
            clean_time(obj){
                if(obj.clean_timeLoading){
                    return
                }
                let purifierId = obj.id;
                this.$confirm(
                    this.$t('App.message.text40'), this.$t('App.message.text17'), {
                        confirmButtonText: this.$t('App.message.text2'),
                        cancelButtonText: this.$t('App.message.text6'),
                        type: 'warning'
                    }
                ).then(() => {
                    obj.clean_timeLoading = true;
                    base.ajax_post(
                        allUrl.roomLight.clean_time,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            purifierId:purifierId,
                        },
                        {},
                        data=>{
                            this.getPurifierList();
                            this.$message({
                              showClose: true,
                              message: data.msg,
                              type: 'success'
                            });
                            obj.clean_timeLoading = false;
                        },
                        this,()=>{
                            obj.clean_timeLoading = false;
                        }
                    )
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('App.message.text18')
                    });          
                });
            },
            /*删除设备*/
            postDelLight(obj,type,delDelIs_true){
                let purifierId = '',isTrue = true;
                if(type == 'batch'){
                    if(obj.length == 0){
                        isTrue = false;
                        this.$message({
                            message: this.$t('App.message.text11'),
                            type: 'warning'
                        });
                    }else{
                        for(let id of obj){
                            if(purifierId == ''){
                                purifierId = id;
                            }else{
                                purifierId += ','+id;
                            }
                        }
                    }
                }else{
                    this.delDelIs_true = delDelIs_true
                    purifierId = obj.id;
                }
                if(isTrue){
                    this.$confirm(
                        delDelIs_true==1?this.$t('App.message.delDevText'):this.$t('App.message.text16'), this.$t('App.message.text17'), {
                            confirmButtonText: this.$t('App.message.text2'),
                            cancelButtonText: this.$t('App.message.text6'),
                            type: 'warning'
                        }
                    ).then(() => {
                        base.ajax_postWs(
                            allUrl.roomLight.delPurifier,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                purifierId:purifierId,
                                clientId:this.clientid,
                                is_true:this.delDelIs_true
                            },
                            this
                        )
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: this.$t('App.message.text18')
                        });          
                    });
                }
            },
            /*设备列表*/
            getPurifierListKeyUp(e){
                if(e.key == 'Enter'){
                  this.getPurifierList();
                }
            },
            getPurifierList(callback){
                if(this.buildId){
                    this.loading.purifierDataList = true;
                    base.ajax_post(
                        allUrl.roomLight.purifierList,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            buildId:this.buildId,
                            // roomId:this.roomId,
                            page:this.currentPage,
                            count:this.pageSize,
                            type:'0',
                            keywords:this.keywords,
                        },
                        {},
                        data=>{
                            this.purifierDataList = data.data.list;
                            this.total = Number(data.data.total);
                            this.loading.purifierDataList = false;

                            this.purifierDataIdList = [];
                            this.checkList = [];
                            this.isIndeterminate = false;
                            this.checkAll = false;
                            let i = 1 + (this.currentPage-1)*this.pageSize;
                            for(let d of this.purifierDataList){
                                this.$set(d,'statusLoading',false);
                                this.$set(d,'clean_timeLoading',false);

                                this.purifierDataIdList.push(d.id);
                                d.status = Number(d.status)
                                d.webIndex = i;
                                i++;
                            }
                            if(callback){
                                callback(data)
                            }
                            this.$nextTick(function(){
                                this.$refs.purifierDataList.doLayout();
                            })
                        },
                        this,()=>{
                            this.loading.purifierDataList = false;
                        }
                    )

                }
            },
            /*楼房下拉列表*/
            getBuildNav(callback){
                if(this.hotelId){
                    base.ajax_post(
                        allUrl.room.buildNav,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            hotelId:this.hotelId,
                        },
                        {},
                        data=>{
                            this.buildNav = data.data.list;
                            if(callback){
                                callback(data)
                            }
                        },
                        this
                    )
                }
            },
            /*楼层下拉列表*/
            getFloorNav(callback){
                base.ajax_post(
                    allUrl.room.floorNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:this.buildId,
                    },
                    {},
                    data=>{
                        this.floorNav = data.data.list;
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*楼间下拉列表*/
            getRoomNav(callback){
                base.ajax_post(
                    allUrl.room.roomNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:this.buildId,
                        floorId:this.purifierForm.floorId,
                    },
                    {},
                    data=>{
                        this.roomNav = data.data.list;
                        console.log(this.roomNav)
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            plSwitchFun(data){
                if(!data.statusLoading){
                    if(data.online == 0){
                        this.$notify({
                            message: this.$t('App.message.text9'),
                            type: 'warning'
                        });
                    }else if(data.blueStatus==0){
                        this.$notify({
                            message: this.$t('App.message.text15'),
                            type: 'warning'
                        });
                    }else{
                        this.status_ = data.status;
                        this.level_ = data.level;
                        if(data.status == 1){
                            data.status = 0
                        }else{
                            data.status = 1
                        }
                        data.statusLoading = true;
                        base.ajax_postWs(
                            allUrl.roomLight.trunOffDevice,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                purifierId:data.id,
                                status:data.status,
                                level:data.level,
                                clientId:this.clientid,
                            },
                            this
                        )
                    }
                }
            },
            handleCommand(obj){
                if(!obj.data.statusLoading){
                    if(obj.data.online == 0){
                        this.$notify({
                            message: this.$t('App.message.text9'),
                            type: 'warning'
                        });
                    }else if(obj.data.blueStatus==0){
                        this.$notify({
                            message: this.$t('App.message.text15'),
                            type: 'warning'
                        });
                    }else{
                        this.level_ = obj.data.level;
                        this.status_ = obj.data.status;
                        if(obj.data.openType  != obj.val){
                            obj.data.level = obj.val;
                            obj.data.statusLoading = true;
                            base.ajax_postWs(
                                allUrl.roomLight.trunOffDevice,
                                {
                                    username:this.username,
                                    client_key:this.client_key,
                                    token:this.token,
                                    purifierId:obj.data.id,
                                    status:obj.data.status,
                                    level:obj.data.level,
                                    clientId:this.clientid,
                                },
                                this
                            )
                        }
                    }
                }
            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
                this.currentPage = 1;
                this.getPurifierList();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getPurifierList();
                // console.log(val)
            },
            handleSizeChange2(val) {
                this.pageSize2 = val;
                this.purifierLogList(this.purifierId,this.timeType2,0);
            },

            handleCurrentChange2(val) {
                this.currentPage2 = val;
                this.purifierLogList(this.purifierId,this.timeType2,0);
                // console.log(val)
            },

            handleCheckAllChange(val) {
                this.checkList = val ? this.purifierDataIdList : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value){
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.purifierDataIdList.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.purifierDataIdList.length;
            },
        },
        watch:{
            hotelId:function(){
                this.getBuildNav(()=>{
                    if(this.buildNav.length > 0){
                        this.buildId = this.buildNav[0].id;
                        this.getFloorNav(data=>{
                            this.tableFloorNav = data.data.list
                        })
                    }else{
                        this.buildId ='';
                    }
                    this.currentPage = 1;
                    this.getPurifierList();
                });
            },
            buildId:function () {
                this.currentPage = 1;
                this.getPurifierList();
            },
            updateRemRatio:function(){
                clearTimeout(this.updateRemRatioShakeProof)
                this.updateRemRatioShakeProof = setTimeout(()=>{
                    this.lightArr = [
                        {prop:'floor',label:this.$t('App.room.text29'),minWidth:5*this.remRatio},
                        {prop:'roomNumber',label:this.$t('App.room.text30'),minWidth:5*this.remRatio},
                        {prop:'status',label:this.$t('App.room_light.text46'),minWidth:5*this.remRatio,type:1,align:'left'},
                        {prop:'level',label:this.$t('App.airPurifiers.text6'),minWidth:6*this.remRatio,type:1,align:'left'},

                        {prop:'pm25',label:'PM2.5',minWidth:5*this.remRatio,unit:'ug/m³'},
                        {prop:'TVOC',label:'TVOC',minWidth:5*this.remRatio,unit:'ppb',type:1},

                        {prop:'workTime',label:this.$t('App.airPurifiers.text2'),minWidth:13.5*this.remRatio,unit:'h'},
                        {prop:'useTime',label:this.$t('App.airPurifiers.text3'),minWidth:12*this.remRatio,unit:'h'},
                        {prop:'online',label:this.$t('App.lights.text30'),minWidth:8*this.remRatio,type:1},
                        {prop:'updateTime',label:this.$t('App.airPurifiers.text16'),width:11.5*this.remRatio},
                    ];
                    this.$nextTick(function(){
                        this.$refs.purifierDataList.doLayout();
                    })
                },1000)
            }
        }
    }
</script>

<style type="text/css" lang="less">
    .airPurifiers_main{
        width: 100%;
        height: 100%;
        // height: 105rem;
        min-height: 50rem;
        // min-width: 120rem;
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        display: flex;
        background: #F6F8FA;
        &.cn{
            .airPurifiers_right{
                .airPurifiers_right_top .right_top_l > .el-input .el-icon-search{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
                .airPurifiers_right_main .main_cont{
                    .el-table .brightness .btn_img .bg{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                    .el-table .btn:hover i{
                        color: #8266C7;
                    }
                    .el-table .open .pl_switch{
                        &.checked{
                            &::after{
                                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                            }
                        }
                    }
                    .pagination_box .el-pager li{
                        &:hover{
                            color: #513C93;
                            background:rgba(130,102,199,0.1);
                        }
                        &.active{
                            color: #FFFFFF;
                            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        }
                    }
                    .el-table .open .pl_switch.checked::after{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                }
            }
            .history_warp .history_box{
                .table_box .pagination_box .el-pager li{
                    &:hover{
                        color: #513C93;
                        background:rgba(130,102,199,0.1);
                    }
                    &.active{
                        color: #FFFFFF;
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                }
                .table_top_box .box1 .btn.select{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
            }
            .purifier_wrap .purifier_box .btn_box .btn{
                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
            }
        }
        .airPurifiers_left{
            width: 11.67rem;
            height: 100%;
            min-width: 130px;
        }
        .airPurifiers_right{
            position: relative;
            padding: 1.92rem 1.5rem 0;
            width: calc(100% - 11.67rem);
            height: calc(100%);
            .airPurifiers_right_top{
                display: flex;
                justify-content: space-between;
                .right_top_l{
                    .el-input__inner{
                        height: 2.5rem;line-height: 2.5rem;
                        border-radius: 1.25rem;
                        font-family: AlibabaPuHuiTiR;
                        font-size: 1rem;
                        color: #333333;
                        border-color: #F0F0F0;
                    }
                    .el-input__icon{
                        height: 2.5rem;line-height: 2.5rem;
                    }
                    .el-select{
                        width: 11.42rem;
                    }
                    >.el-input{
                        margin-left: 1rem;
                        width: 20rem;
                        .el-icon-search{
                            display: inline-block;
                            top: 0;bottom: 0;
                            right: 0;
                            width: 4rem;
                            background: #05CFAB;
                            border-radius: 1.25rem;
                            cursor: pointer;
                            color: #FFFFFF;
                        }
                        .el-input__suffix{
                            right: 0;
                        }
                    }
                }
            }
            .airPurifiers_right_main{
                height: calc(100% - 6.5rem);
                margin-top: 1rem;
                position: relative;
                background: #FFFFFF;
                border: 1px solid #F0F0F0;
                border-radius: 0.4rem;
                .main_top{
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 1.67rem 0;
                    .main_top_l{
                        .div1{
                            margin-top: 1.5rem;
                            font-family: AlibabaPuHuiTiB;
                            font-size: 1.5rem;
                            color: #333333;
                        }
                        .div2{
                            margin-top: 1.33rem;
                            display: flex;
                            .btn{
                                margin-left: 1.29rem;
                                display: flex;align-items: center;
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #333333;
                                cursor: pointer;
                                i{
                                    font-size:0.8rem;
                                    color: #C6CDD5;
                                }
                                span{
                                    margin-left: 0.5rem;
                                }
                            }
                        }
                    }
                    .main_top_r{
                        margin-top: 2.33rem;
                        display: flex;
                        .btn{
                            margin-left: 1rem;
                            height: 2.5rem;line-height: 2.5rem;
                            padding: 0 1.25rem;
                            background: #FFFFFF;
                            border: 1px solid #F0F0F0;
                            border-radius: 1.25rem;
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            img{
                                margin-right: 0.5rem;
                                height: 1rem;
                            }
                        }
                    }
                }
                .main_cont{
                    height: calc(100% - 11rem);
                    margin-top: 0.75rem;
                    .el-checkbox-group{
                        height: 100%;
                    }
                    .el-table{
                        .el-checkbox{
                            margin-left: 1.1rem;
                        }
                        .btn{
                            padding: 0.5rem;
                            cursor: pointer;
                            &+.btn{
                                margin-left: 0.2rem;
                            }
                            i{
                                color: #A3AFBB;
                                font-size:0.8rem;
                            }
                            &:hover{
                                i{
                                    color: #05CFAB;
                                }
                            }
                        }
                        th{
                            font-weight:initial;
                            height: 3rem;
                            border-top: 1px solid #F0F0F0;
                            border-bottom: 1px solid #F0F0F0;
                            padding: 0;
                            background: #F6F8FA;
                            &>.cell{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #333333;
                                padding: 0;
                            }
                        }
                        td{
                            padding: 0;
                            height: 3rem;
                            &>.cell,.el-checkbox__label{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #657085;
                            }
                        }
                        .cell{
                            padding: 0;
                            .el-loading-spinner{
                                margin-top: -0.75rem;
                                .circular{
                                    width: 1.5rem;height: 1.5rem;
                                }
                            }
                        }
                        .el-loading-spinner{
                            height: 100%;
                            margin-top: 0;top: 50%;
                        }
                        .open{
                            display: flex;
                            align-items: center;
                            width: 99%;
                            .pl_switch{
                                position: relative;
                                display: inline-block;
                                width: 2.33rem;
                                height: 1.3rem;
                                background: #E1EAF1;
                                border-radius: 1.08rem;
                                cursor: pointer;
                                &::after{
                                    position: absolute;
                                    left: 0.2rem;top: 0.15rem;
                                    width: 0.93rem;height: 0.93rem;border-radius: 50%;
                                    content: '';
                                    background: #A3AFBB;
                                    transition: all 0.5s;
                                }
                                &.checked{
                                    background: #E1F1E7;
                                    &::after{
                                        left: 1.15rem;
                                        background: #05CFAB;
                                    }
                                }
                            }
                        }
                        .level{
                            position: relative;
                            .el-dropdown{
                                margin-left: 0.83rem;
                                cursor: pointer;
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #657085;
                            }
                            .disabled{
                                position: absolute;
                                display: inline-block;
                                width: 100%;
                                height: 100%;
                                top: 0;
                                left: 0;
                                cursor: no-drop;
                            }
                        }
                        .online{
                            width: 4.8rem;
                            height: 1.8rem;
                            line-height: 1.8rem;
                            background: rgba(246,248,250,1);
                            border-radius: 0.67rem;
                            margin: 0 auto;
                            span{
                                position: relative;
                                margin: 0 0.3rem;
                                color:rgba(235, 239, 242, 1);
                            }
                            .iconfont{
                                font-size: 1.2rem;
                            }
                        }
                    }
                    .pagination_box{
                        .el-pagination{
                            float: right;
                            margin-top: 0.5rem;
                        }
                        height: 2.5rem;line-height: 2.5rem;
                        .btn-prev .el-icon{
                            font-size:1rem;
                            color: #666666;
                            font-family: PingFang-SC-Medium;
                        }
                        button{
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                        }
                        .el-pager li{
                            margin-left: 0.83rem;
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                            &:hover{
                                color: rgba(5,207,171,1);
                                background-color: rgba(5,207,171,0.1);
                            }
                        }
                        .btn-next{
                            margin-left: 0.83rem;
                        }
                        .el-pager li.active{
                            background: #05CFAB;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }
        .purifier_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .purifier_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .purifier_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.5s;
                &.purifier_tk_show{
                    right: 0rem; 
                }
                .purifier_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 1.96rem;
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 0 1.08rem;
                        background: #F6F8F7;
                        position: relative;
                        .unit{
                            position: absolute;
                            top: 0;
                            right: 0;
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #657085;
                        }
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-dropdown{
                            cursor: pointer;
                            i{
                                margin-left: 1.67rem;
                            }
                        }
                        .el-input-number{
                            width: calc(100% - 15rem);
                            .el-input{
                                width: 100%;
                            }
                        }
                        .el-input{
                            width: calc(100% - 8rem);
                            .el-input__inner{
                                font-family: PingFang-SC-Medium;
                                font-size: 1rem;
                                color: #657085;
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .history_warp{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .history_warp_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            .history_box{
                position: absolute;
                width: 80.42rem;height: 100%;min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -80.42rem;
                transition: all 0.5s;
                &.history_show{
                   right: 0rem; 
                }
                .history_top{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .filter_box{
                    height: 4.3rem;
                    padding: 1.63rem 0 0rem;
                    padding-left: 2.5rem;
                    .el-select{
                        margin-right: 0.83rem
                    }
                    .el-input__inner,.el-input__icon{
                        height: 2.5rem;line-height: 2.5rem;
                    }
                    .el-input__inner{
                        border-radius: 1.25rem;
                    }
                }
                .table_top_box{
                    position: relative;
                    .download_btn{
                        position: absolute;
                        right: 3rem;top: 0.12rem;

                        height: 2.5rem;line-height: 2.5rem;
                        padding: 0 1.25rem;
                        background: #FFFFFF;
                        border: 1px solid #F0F0F0;
                        border-radius: 1.25rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #333333;
                        cursor: pointer;
                    }
                    .box1{
                        display: flex;
                        width: 18.5rem;height: 2.75rem;line-height: 2.75rem;
                        background-color:rgba(246, 248, 250, 1);
                        border-radius:1.38rem;
                        margin: 0.8rem auto 0.8rem;
                        .btn{
                            flex: 1;
                            text-align: center;
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiR;
                            color:rgba(51,51,51,1);
                            cursor: pointer;
                            &.select{
                                background-color:rgba(5, 207, 171, 1);
                                color:rgba(255,255,255,1);
                                border-radius:1.67rem;
                            }
                        }
                    }
                }
                .echarts_warp{
                    height:calc(100%  - 13rem);
                }
                .echarts_box{
                    height: calc(17rem);
                    margin: 0 1.8rem 1.67rem 2.5rem;
                    background: #F6F8F7;
                    border-radius: 5px;
                    .echarts_top{
                        padding-left: 1.67rem;
                        line-height: 2.5rem;
                        font-family: AlibabaPuHuiTiB;
                        font-size: 1rem;
                        color: #333333;
                    }
                    .history_echarts_tooltip{
                        background-color:#fff;
                        padding: 0.3rem 1rem 0.67rem 0;
                        .p1{
                            display: flex;
                            align-items: center;
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiM;
                            color:rgba(51,51,51,1);
                            i{
                                margin-left: 0.92rem;
                                margin-right: 0.5rem;
                                display: inline-block;
                                width: 0.25rem;height: 0.25rem;
                                border-radius: 50%;
                            }
                            .span1{
                                margin-right: 0.3rem;
                            }
                        }
                        .p2{
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiM;
                            color:rgba(163,175,187,1);
                            padding-left: 1.75rem;
                        }

                    }
                    .history_echarts_box1{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box2{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box3{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box4{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box5{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box6{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box7{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                }
                .table_box{
                    height: calc(100% - 17rem);
                    .el-table{
                        .el-loading-spinner{
                            margin-top: -0.75rem;
                            .circular{
                                width: 1.5rem;height: 1.5rem;
                            }
                        }
                        th{
                            font-weight:initial;
                            height: 3rem;
                            border-top: 1px solid #F0F0F0;
                            border-bottom: 1px solid #F0F0F0;
                            padding: 0;
                            background: #F6F8FA;
                            &>.cell{
                                height: 3rem;line-height: 3rem;
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #333333;
                            }
                            div{
                                height: 3rem;line-height: 3rem;
                            }
                        }
                        td{
                            padding: 0;
                            height: 3rem;
                            &>.cell,.el-checkbox__label{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #657085;
                            }
                        }
                        .brightness{
                            display: flex;
                            align-items: center;
                            justify-content:flex-end;
                        }
                        .color{
                            display: flex;
                            align-items: center;
                            justify-content:center;
                        }
                        .alarmStatus{
                            .text_1{
                                color: rgba(255,12,77,1);
                                img{
                                    margin-left: 0.2rem;
                                }
                            }   
                        }
                    }
                    .pagination_box{
                        margin-top: 0.5rem;
                        .el-pagination{
                            float: right;
                            // margin-top: 0.5rem;
                            padding:0;
                        }
                        height: 2.5rem;line-height: 2.5rem;
                        .btn-prev .el-icon{
                            font-size:1rem;
                            color: #666666;
                            font-family: PingFang-SC-Medium;
                        }
                        button{
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                        }
                        .el-pager li{
                            margin-left: 0.83rem;
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                            &:hover{
                                color: rgba(5,207,171,1);
                                background-color: rgba(5,207,171,0.1);
                            }
                        }
                        .btn-next{
                            margin-left: 0.83rem;
                        }
                        .el-pager li.active{
                            background: #05CFAB;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }
        .purifierSetting_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .purifierSetting_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 58rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .purifierSetting_box{
                position: absolute;
                width: 40rem;height: 100%;
                min-height: 58rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -40rem;
                transition: all 0.5s;
                &.purifierSetting_tk_show{
                    right: 0rem; 
                }
                .purifierSetting_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 1.96rem;
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 0 1.08rem;
                        background: #F6F8F7;
                        position: relative;
                        .unit{
                            position: absolute;
                            top: 0;
                            right: 0.5rem;
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #657085;
                        }
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-dropdown{
                            cursor: pointer;
                            i{
                                margin-left: 1.67rem;
                            }
                        }
                        .el-input{
                            width: calc(100% - 8rem);
                            .el-input__inner{
                                font-family: PingFang-SC-Medium;
                                font-size: 1rem;
                                color: #657085;
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                        .el-date-editor{
                            width: calc(100% - 16rem);
                        }
                        .el-input-number{
                            width: calc(100% - 16rem);
                            margin-right: 1rem;
                            .el-input{
                                width: 100%;
                            }
                        }
                    }
                    .form_item1{
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 1rem 1.08rem;
                        background: #F6F8F7;
                        .label_t{
                            line-height:3rem;
                        }
                        .table{
                            margin: 0rem 0;
                            .tr{
                                display: flex;
                                margin-bottom: 0.5rem;
                                .th,.td{
                                    // padding: 0 0.4rem;
                                    font-size:1rem;
                                    font-family:PingFang-SC-Medium,PingFang-SC;
                                    font-weight:500;
                                    color:rgba(51,51,51,1);
                                    .el-input{
                                        font-size:1rem;
                                        font-family:PingFang-SC-Medium,PingFang-SC;
                                        font-weight:500;
                                        color:rgba(51,51,51,1);
                                    }
                                    // flex: 1;
                                    &.w_1{
                                        width: 11%;
                                    }
                                    &.w_2{
                                        width: 23%;
                                    }
                                    &.w_3{
                                        width: 8%;
                                    }
                                    &.w_4{
                                        width: 16%;
                                    }
                                    &.w_5{
                                        width: 1%;
                                    }
                                    &.text-left{
                                        text-align: left;
                                    }
                                    &.text-right{
                                        text-align: right;
                                    }
                                }
                                .th{
                                    text-align: center;
                                    height: 2rem;line-height:2rem;
                                }
                                .td{
                                    height: 3rem;line-height:3rem;
                                    color: #606266;
                                    font-size:1rem;
                                    position: relative;
                                    .text{
                                        background:rgba(246,248,247,1);
                                        display: inline-block;
                                        width: 100%;
                                        // padding: 0 0.4rem;
                                        box-sizing: border-box;
                                    }
                                    .tips{    
                                        position: absolute;
                                        top: 1.6rem;
                                        left: 0;
                                        display: inline-block;
                                        width: 100%;
                                        text-align: center;
                                    }
                                    // .el-input{
                                    //     .el-input__inner{
                                    //         // border: none;
                                    //         height: 3rem;line-height:3rem;
                                    //         background:rgba(246,248,247,1);
                                    //     }
                                    // }
                                }
                            }
                        }
                        .el-input-number{
                            width: 100%;
                            line-height:2rem;
                            // margin: 0 1rem;
                            margin: 0 1rem;
                            width: calc(100% - 2rem);
                            .el-input{
                                .el-input__inner{
                                    padding:0;
                                    height: 2rem;line-height:2rem;
                                }
                            }
                        }
                        .el-select{
                            width: 100%;
                            margin: 0 1rem;
                            line-height:2rem;
                            width: calc(100% - 2rem);
                            .el-input{
                                .el-input__inner{
                                    padding:0 0.5rem;
                                    height: 2rem;line-height:2rem;
                                }
                                .el-input__suffix{
                                    .el-input__icon{
                                        height: 2rem;line-height:2rem;
                                    }
                                }
                            }
                        }
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .gatewayUpdate_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .gatewayUpdate_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .gatewayUpdate_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.5s;
                &.gateway_tk_show{
                    right: 0rem; 
                }
                .gatewayUpdate_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .box1{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width:calc(100% - 5rem);
                    height:5.08rem;
                    margin:2.5rem auto 0;
                    padding: 0 1.5rem;
                    background:rgba(246,248,247,1);
                    img{
                        height: 3rem;
                    }
                    span{
                        font-size:1.67rem;
                        font-family:AlibabaPuHuiTiH;
                        color:rgba(51,51,51,1);
                    }
                }
                .p1{
                    width:calc(100% - 5rem);
                    margin:0.75rem auto 0;
                    height:1.42rem;
                    line-height:1.42rem;
                    font-size:1rem;
                    font-family:AlibabaPuHuiTiR;
                    color:rgba(101,112,133,1);
                }
                .btn_box{
                    width:calc(100% - 5rem);
                    margin:2rem auto 0;
                    height:2.67rem;
                    background:rgba(5, 207, 171, 0.1);
                    .btn{
                        width: 100%;height: 100%;line-height: 2.67rem;
                        text-align: center;
                        background:rgba(5,207,171,1);
                        border-radius:0.17rem;

                        font-size:1rem;
                        font-family:PingFang-SC-Medium,PingFang-SC;
                        font-weight:500;
                        color:rgba(255,255,255,1);
                        cursor: pointer;
                    }
                    .el-progress{
                        .el-loading-mask{
                            background: rgba(255,255,255,0.1);
                        }
                        .el-progress-bar__outer{
                            height: 2.67rem;
                            background-color:initial;
                            border-radius: 0;
                            .el-progress-bar__inner{
                                border-radius: 0;
                                background-color:rgba(5, 207, 171, 1);
                            }
                        }
                    }
                    .text{
                        width: 100%;height: 100%;line-height: 2.67rem;
                        text-align: center;
                        border-radius:0.17rem;
                        font-size:1rem;
                        font-family:PingFang-SC-Medium,PingFang-SC;
                        font-weight:500;
                        color:rgba(255,255,255,1);
                        &.span1{
                            background-color: rgba(255, 12, 77, 1);
                            cursor:pointer;
                        }
                        &.span2{
                            background-color: rgba(165, 201, 195, 1);
                        }
                    }
                }
            }
        }
    }
</style>